<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Employees</li>
      </ol>
    </div>
    <div class="main-box bg-transparent employee-page">
      <div class="top-summary">
        <div class="row">
          <div class="col-lg-5 col-md-12 employees">
            <div class="emp-summary">
              <div class="emp-title">
                <h3>Employee Summary</h3>
                <p>
                  You currently have {{ employeeCount }} employees in
                  <span class="text-capitalize">{{ this.$store.getters.getSelectedCompany.name }}</span>
                </p>
              </div>
              <div class="emp-title">
                <p class="logged-text text-right">
                  <span class="pr-5 col-blue"> {{ isLoginCount }} Employees </span>have
                  logged in yet.
                </p>
                <p class="col-blue text-right pt-15">
                  <a href="javascript:void(0);" class="pr-5" :class="{ 'active-tab': employeeType === 'all' }" @click="searchByType('all')">All</a>
                  <a href="javascript:void(0);" class="pr-5" :class="{ 'active-tab': employeeType === 'current' }" @click="searchByType('current')">Current</a>
                  <a href="javascript:void(0);" class="pr-5" :class="{ 'active-tab': employeeType === 'terminate' }" @click="searchByType('terminate')">Terminated</a>
                  <a href="javascript:void(0);" class="pr-5" :class="{ 'active-tab': employeeType === 'unverified' }" @click="searchByType('unverified')">Unverified</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-12 employees">
            <div class="emp-serch-summary">

              <div class="emp-button btn-align">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  @click="showEmpCreateModal"
                >
                  Create new employee
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  data-toggle="modal"
                  @click="showInviteModal"
                >
                  Invite Employee
                </button>
                <router-link to="/employees/import" class="btn btn-outline-primary">
                  Import Employees
                </router-link>
                <button type="button" class="btn btn-delete btn-xs btn-outline-danger" @click="deleteSelectedEmployees()" v-if="selectedEmployees.length > 0">
                  Delete
                </button>
              </div>
              <div class="searchbar-holder">
                <div class="input-wrapper">
                  <!-- <input type="text" class="form-control " placeholder="Search"> -->
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search"
                    v-model="search"
                    @keyup="searchEmployees"
                    readonly
                    autocomplete="off"
                    onfocus="this.removeAttribute('readonly');"
                    value=""
                  />
                  <i class="ico ico-Search"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-box two-column">
        <div class="right-side right-side-reverse">
          <ul class="emp-menu">
            <li :class="roleActive">
              <a href="javascript:void(0)" @click="allEmployeeAfterFilter"
                ><span class="bg-role" style="background:rgb(152, 152, 152);"></span><i class="ico ico-fill-circle"></i> All</a
              >
            </li>
            <li
              :class="{ active: roleActive2 === index }"
              v-for="(role, index) of jobRoles.jobRoles"
              :key="index"
              @click="filterByJobType(role.id, index)"
            >
              <a href="javascript:void(0)"
                >
                <span class="bg-role" :style="{background:role.color}"></span>
                <i
                  class="ico ico-fill-circle"
                  v-bind:style="{
                    color: role.color !== null ? role.color : '',
                  }"
                ></i>
                {{ role.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="cards-panel">




          <div class="cards-panel-thead">
            <div class="thead-th" style="width: 20px;flex-shrink: 0;flex-grow: unset; margin-right:10px; margin-top:2px;"><input type="checkbox" v-model="selectAll" @change="selectAllEmployees"></div>
            <div class="thead-th" style="flex-grow:1;">Name</div>
            <div class="thead-th">

              <span style="width: 155px;display: inline-block;">Phone Number</span>
              <span style="width: 308px;display: inline-block;">Email Adress</span>
            </div>
            <div class="thead-th">Action</div>
          </div>

          <div class="employee-card" style="border: 1px solid #00779c;" v-if="employeeType ==='all' || employeeType ==='current'">
            <div class="card-head">
              <div class="emp-col" style="width: 20px;flex-shrink: 0;flex-grow: unset;margin-right:10px;"></div>
              <div class="profile-img">
                <router-link :to="{ path: '/employee/profile/' + admin.uuid + '' }">
                  <img :src="$API_URL+'storage/'+admin.image"
                       alt="Profile image"
                       width="80"
                       height="80"
                       v-if="admin.image !== ''"
                  />
                  <span v-else-if="admin.image === ''" class="profile-name text-uppercase">
                     {{ (admin.name)&& isNaN(admin.name) ? String(admin.name).slice(0,1)+String(admin.name.split(' ')[1]).slice(0,1): '' }}
                  </span>

                </router-link>
              </div>
              <div class="employee-title">
                <h3 class="emp-name text-capitalize">
                  <router-link :to="{ path: '/employee/profile/' + admin.uuid + '' }">
                    {{
                      admin.name
                    }}
                  </router-link>
                  <span v-if="admin.is_login==1">
                    <i class="ico-mobile text-primary" :title=" admin.last_activity_date | moment(' D MMM YYYY')"></i>
                  </span>
                  <small v-if="admin.is_terminate==1" class="text-danger">(Terminated)</small>
                </h3>
                <span class="emp-designation">
                  <span v-for="role of admin.jobRoles" :key="role.id">
                    &nbsp;<i class="ico ico-fill-circle" v-bind:style="{color:role.get_job_roles !== null? role.get_job_roles.color: '',}"></i>
                    {{
                      role.get_job_roles !== null ? role.get_job_roles.name : ""
                    }}
                  </span>
                </span>
              </div>
            </div>
            <div class="employee-card-holder" style="width: 510px;">
              <div class="emp-col">
                <a href="tel:+4733378901" class="ovr-hidden">{{
                    admin.phone
                  }}</a>
              </div>
              <div class="emp-col">
                <a href="mailto:someone@example.com" class="ovr-hidden" >
                  {{ admin.email}}
                </a>
              </div>
            </div>
            <router-link
              href="javascript:void(0)"
              class="btn btn-delete btn-outline-danger"
              :to="{ path: '/employee/profile/' + admin.uuid + '' }"
            ><i class="ico-pencil"></i
            ></router-link>
          </div>

          <div class="employee-card" v-for="(empl, index) of companyEmployees" :key="index">
            <div class="emp-col" style="width: 20px;flex-shrink: 0;flex-grow: unset; margin-right:10px; margin-top:16px;">
              <input type="checkbox" :value="empl.id" v-model="selectedEmployees">
            </div>
            <div class="card-head">
              <div class="profile-img">
                <router-link :to="{ path: '/employee/profile/' + empl.uuid + '' }">
                  <img :src="$API_URL+'storage/'+empl.image"
                    alt="Profile image"
                    width="80"
                    height="80"
                    v-if="empl.image !== ''"
                  />
                  <span v-else-if="empl.image === ''" class="profile-name text-uppercase">
                     {{ (empl.name)&& isNaN(empl.name) ? String(empl.name).slice(0,1)+String(empl.name.split(' ')[1]).slice(0,1): '' }}
                 </span>

                </router-link>
              </div>
              <div class="employee-title">
                <h3 class="emp-name text-capitalize">
                  <router-link :to="{ path: '/employee/profile/' + empl.uuid + '' }">
                    {{
                      empl.name
                    }}
                  </router-link>
                  <span v-if="empl.is_login==1">
                    <i class="ico-mobile text-primary" :title=" empl.last_activity_date | moment(' D MMM YYYY')"></i>
                  </span>
                   <small v-if="empl.is_terminate==1" class="text-danger">(Terminated)</small>
                </h3>
                <span class="emp-designation">
                  <span v-for="role of empl.employeeJobType" :key="role.id">
                    &nbsp;<i class="ico ico-fill-circle" v-bind:style="{color:role.get_job_roles !== null? role.get_job_roles.color: '',}"></i>
                    {{
                      role.get_job_roles !== null ? role.get_job_roles.name : ""
                    }}
                  </span>
                </span>
              </div>
            </div>
            <div class="employee-card-holder">
              <div class="emp-col">
                <a href="tel:+4733378901" class="ovr-hidden">{{
                  empl.phone
                }}</a>
              </div>
              <div class="emp-col">
                <button class="ovr-hidden btn btn-outline-primary" @click="showInvitaionModal(empl.id)" v-if="empl.status === 'UN_VERIFIED'">
                  Send Invitation Again
                </button>
                <a href="mailto:someone@example.com" class="ovr-hidden" v-else>
                  {{ empl.email}}
                </a>

              </div>
            </div>
            <router-link
              href="javascript:void(0)"
              class="btn btn-delete btn-outline-danger"
              :to="{ path: '/employee/profile/' + empl.uuid + '' }"
              ><i class="ico-pencil"></i
            ></router-link>
            <button
              type="button"
              class="btn btn-delete btn-outline-danger"
              @click="deleteEmployee(empl.id)"
            >
              <i class="ico ico-delete"></i>
            </button>
          </div>
          <div v-show="companyEmployees.length >= 15 && loadMoreCheck && companyEmployees.length<employeeCount">
            <a href="javascript:void(0);" v-if="loadMoreEmployeeBtn"  class="btn btn-outline-primary" @click="loadMoreEmployee">Load more</a>
          </div>
          <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
          <div style="text-align: center; margin-top: 20px;" v-show="employeesNotFound">No data found.</div>
        </div>
      </div>
    </div>

    <!-- invitation modal -->
    <div
      class="modal fade write-msg-model creat-employee-modal"
      id="invitaion-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5 v-text="invitaionHeading">Supply the email you want the invitation sent too:</h5>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <p v-text="invitaionDescription">
                We have already sent an invitation email to. We used the supplied email below. If you wish to sent a new invitation email to a different email, please update it below.
              </p>
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col">
                    <input
                      type="email"
                      readonly
                      class="form-control"
                      :value="userEmail"
                    />
                  </div>
                </div>
                <h5>Attach a personal note to the invitation</h5>
                <div class="inputs-holder">
                  <div class="field-col">
                    <textarea class="form-control lg" rows="3" v-model="invitationNote"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0)"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
              >Cancel</a
            >
            <button
              type="button"
              class="btn btn-outline-primary btn-sm f-bold"
              data-dismiss="modal"
              @click="sendInvitaionEmail"
            >
              Send again
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end invitation modal -->


    <!-- creat employee Modal -->
    <createEmployeeModal ref="modal"></createEmployeeModal>
    <!-- creat employee Modal -->

    <!-- invite employee Modal -->
    <div
      class="modal fade write-msg-model send-invitation-model"
      id="invite-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
      :class="{'show':inviteModel===true}"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Invite Employees</h5>
              <p class="gray-text">Send your staff an invitation to join.</p>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearInviteReq"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              By Sending Invite, Your Employees Will Be Able To Download
              CleverStaff And Join Your Company
            </p>
            <strong class="col-blue text-capitalize">
              {{ this.$store.getters.getSelectedCompany.name }}
            </strong>
          </div>
          <div class="modal-footer">
            <div class="field-col">
              <label>Phone Number:</label>
              <VuePhoneNumberInput
                v-model.trim="inviteNumber"
                :default-country-code="countryCode"
                size="sm"
                @update="getFormatedNum"
                :clearable="true"
                :translations="{countrySelectorLabel: ''}"
                />
                <p v-text="errorMsgePhone" class="textRed"></p>
            </div>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm f-bold"
              id="sendInvite"
              aria-label="Close"
              @click="saveInvite"
              :disabled="disableInviteBtn"
            >
              Send Invite
            </button>
          </div>
          <div class="">
            <div class="field-col" style="padding-left: 19px;
    margin-top: -10px;">
              <p
                v-if="inviteRequired === 'invalid'"
                :class="{ textRed: inviteRequired === 'invalid' }"
              >
                Phone number is required
              </p>
              <p
                v-if="invalidInvite === 'invalid'"
                :class="{ textRed: invalidInvite === 'invalid' }"
              >
                Phone number already exists
              </p>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import collect              from "collect.js";
import createEmployeeModal  from "../Employees/createEmployeeModal";
import VueTelInput          from "vue-tel-input";
import                      "vue-tel-input/dist/vue-tel-input.css";
import VuePhoneNumberInput  from 'vue-phone-number-input';
import                      'vue-phone-number-input/dist/vue-phone-number-input.css';
import ClipLoader           from 'vue-spinner/src/ClipLoader.vue';
import Swal from "sweetalert2";
import moment from 'moment'

export default {
  name: "listEmployees",
  components: { createEmployeeModal, VueTelInput,VuePhoneNumberInput,ClipLoader },
  data() {
    return {
      loadMoreEmployeeBtn       :true,
      countryCode       :'DK',
      filteredEmployees : [],
      employees         : [],
      search            : "",
      editEmployee      : [],
      jobRoles          : this.$store.getters.getSelectedCompany,
      empl_role         : {},
      jobRoleIds        : [],
      employeeCount     : 0,
      checkAttendance   : false,
      salary_period2    : 31,
      type              : "password",
      inviteNumber      : "",
      inviteFormatNumber      : "",
      inviteRequired    : "",

      roleActive        : "active",
      roleActive2       : "",
      invitationNote    :'',
      resendEmployee    :[],
      userEmail         :'',
      imgNotFnd         :false,
      invalidInvite     :'',
      employeesNotFound :false,
      size              : '25px',
      spinnerColor      : '#00779C',
      loadingSpin       : false,
      inviteModel       : false,
      limit             : 0,
      errorMsgePhone        : '',
      disableInviteBtn      : false,
      invitaionHeading      : '',
      isCompanyMembership   : true,
      invitaionDescription  : '',
      page                  : 1,
      totalEmployees        : [],
      isReferBY: (this.$store.getters.getUser.refer_by !='' || this.$store.getters.getUser.refer_by !=null) ? true: false,
      loadMoreCheck : true,
      admin : this.$store.getters.getUser,

      totalStoredEmployees : [],
      companyEmployees : [],
      employeesPerPage: 20, // Number of employees to load per page
      currentPage: 1, // Current page number
      isLoginCount: 0,
      selectedEmployees: [], // Array to store IDs of selected employees
      selectAll: false, // Boolean to track select all checkbox state
      employeeType: 'all'
    };
  },
  created(){
    //this.$store.commit('setUser', res.data.result);
  },
  mounted() {
    this.totalStoredEmployees = JSON.parse(localStorage.getItem('companyEmployees'));
    if (this.totalStoredEmployees != null) {
      // Sort the employees alphabetically by their names
      this.totalStoredEmployees.sort((a, b) => a.name.localeCompare(b.name));
      // Store the sorted list back to localStorage
      localStorage.setItem('companyEmployees', JSON.stringify(this.totalStoredEmployees));
      // this.companyEmployees = filteredEmployees;
      this.employeeStorage(this.totalStoredEmployees);
    } else {
      this.getEmployees(); // Fetch employees if not available in localStorage
    }
    this.getCompany();
    this.$root.$emit("activeCompoClick");
    this.$root.$on("refreshEmployees", () => {
      this.getEmployees();
    });
    let selcComp      = this.$store.getters.getSelectedCompany;
    this.countryCode  = selcComp.length !== 0 ? (selcComp.currency)?selcComp.currency.ios2:'DK' : 'DK';
    $(document).on('keypress','.input-tel__input',function(e){
      if (this.value.length == 0 && e.which == 48 ){e.preventDefault();}
    });
  },

  methods: {
    employeeStorage(storedEmployees) {
    // Sort employees with terminated employees at the bottom
    const sortedEmployees = storedEmployees.sort((a, b) => {
        if (a.is_terminate && !b.is_terminate) {
            return 1;
        } else if (!a.is_terminate && b.is_terminate) {
            return -1;
        }
        return 0;
    });
    this.totalStoredEmployees = sortedEmployees;
    this.isLoginCount = sortedEmployees.filter(employee => employee.is_login == 1).length;
    this.companyEmployees = sortedEmployees.slice(0, this.employeesPerPage);
    this.filteredEmployees = this.companyEmployees;
    this.totalEmployees = sortedEmployees.length;
    this.employees = this.filteredEmployees;
    this.employeeCount = sortedEmployees.length;
    this.employeesNotFound = this.filteredEmployees.length === 0 ? true : false;
},

    deleteSelectedEmployees() {
      new Swal({
          title: 'Delete Employees!',
          icon: "warning",
          text: "Do you really want to delete employees?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes"
        }).then((result) => {
          if (result.isConfirmed) {
            const selectedIds = this.selectedEmployees.slice();
            this.selectedEmployees = [];
            this.selectAll = false;
            this.$axios({
                method: "POST",
                data: {
                  ids: selectedIds,
                },
                url: this.$DeleteEmployeeBulk,
                headers: this.getAuthHeader(),
              }).then((res) => {
                if (res.data.status == 200) {
                  $root.$toast.success('Deleted Successfully!')
                  this.getEmployees();
                }
              });
          }
        });
    },

    selectAllEmployees() {
      // Toggle selection state of all employees based on selectAll checkbox
      if (this.selectAll) {
        // Select all employees
        this.selectedEmployees = this.companyEmployees.map(employee => employee.id);
      } else {
        // Deselect all employees
        this.selectedEmployees = [];
      }
    },

    sendInvitaionEmail(){
      $('#invitaion-modal').modal('hide');
      this.$axios({
        method: "POST",
          data: {
            employee: this.resendEmployee.length !== 0 ? this.resendEmployee[0] : [],
            note: this.invitationNote
          },
          url: this.$SendAgainInvitaionEmail,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            new Swal({
              title: "Invitation sent!",
              icon: "success",
              text: "",
              type: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok"
            })
          }
        });
    },

    showInvitaionModal(id){
      this.invitationNote = "Our schedule is now available on cleverStaff. I have already created a user for you. Please activate it.";
      this.resendEmployee = this.companyEmployees.filter(item => item.id === id);
      this.userEmail      = this.resendEmployee[0].email?this.resendEmployee[0].email:this.resendEmployee[0].phone;
      this.invitaionHeading = (this.resendEmployee[0].email)?'Supply the email you want the invitation sent too:':'Supply the phone you want the invitation sent too:';
      this.invitaionDescription = (this.resendEmployee[0].email)?'We have already sent an invitation email to. We used the supplied email below. If you wish to sent a new invitation email to a different email, please update it below.':'We have already sent an invitation SMS to. We used the supplied phone number below. If you wish to sent a new invitation SMS on a different phone number, please update it below.'
      $('#invitaion-modal').modal('show');
    },

    allEmployeeAfterFilter() {
      this.companyEmployees  = this.totalStoredEmployees;
      this.roleActive         = "active";
      this.roleActive2        = null;
      this.loadMoreCheck      = true;
      this.employeeCount = Object.keys(this.companyEmployees).length;
    },

    filterByJobType(id, indx) {
      this.loadMoreCheck      = false;
      this.filteredEmployees  = this.companyEmployees;
      this.jobRoles.jobRoles.map((val, indxx) => {
        if (indxx === indx) {
          this.roleActive   = "";
          this.roleActive2  = indxx;
        }
      });
      this.companyEmployees = this.totalStoredEmployees.filter((item) => {
        if (item.employeeJobType.flatMap(obj => obj.job_role_id).includes(id)) {
          return item;
        }
      });
      this.employeeCount = Object.keys(this.companyEmployees).length;
      this.employeesNotFound = this.employeeCount === 0 ? true : false
    },

    deleteEmployee(id) {
      new Swal({
        title: "Delete?",
        icon: "warning",
        text: "Are you sure you want to delete this employee?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
          if (result.value) {
            this.$axios({
              method: "DELETE",
              data: {
                id: id,
              },
              url: this.$DeleteEmployee + `/${id}`,
              headers: this.getAuthHeader(),
            }).then((res) => {
              if (res.data.status == 200) {
                this.getEmployees();
                $root.$toast.success(res.data.message);
              }
            });
          }})

    },
    showInviteModal() {

      if(this.isCompanyMembership===true ||
        this.isReferBY===true ||
      this.$store.getters.getSelectedCompany.partner_customer_no !='')
      {
        this.inviteRequired = "";
        this.invalidInvite = "";
        this.inviteNumber = "";
        this.inviteFormatNumber = "";
        this.inviteModel=true;
      }else{
        new Swal({
          title: "Info",
          icon: "warning",
          text: "Please upgrade your plan",
          type: "info",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok!"
        }).then((result) => {
          if (result.value) {
            this.$router.push('/upgrade-plan');
          }})
      }

    },
    clearInviteReq() {
      this.inviteModel =false;
    },
    getFormatedNum(e){
      let phoneLimit = e.phoneNumber ? e.phoneNumber.replace(/\s/g, '').length : '';
      if(e.isValid == true){
        let numLength = String(e.formatNational).replace(/\s/g, '').length;
        this.limit    = String(e.formatNational).substring(0,1) == 0 ? numLength-1:numLength;
      }
      if(phoneLimit > this.limit && this.limit !== 0){
        this.errorMsgePhone    = "Invalid phone number";
        this.disableInviteBtn  = true;
      }else{
        this.errorMsgePhone     = "";
        this.disableInviteBtn   = false;
        this.inviteFormatNumber = e.formattedNumber;
      }
    },
    saveInvite() {
      if (this.inviteNumber === '') {
        this.inviteRequired='invalid';
        $("#sendInvite").removeAttr("data-dismiss");
      }else{
        this.inviteRequired = "";
        $("#sendInvite").attr("data-dismiss", "modal");
        this.$axios({
          method: "POST",
          data: {
            phone       : this.inviteFormatNumber,
            company_id  : this.$store.getters.getSelectedCompany.id,
            user_id     : this.$store.getters.getUser.id,
          },
          url: this.$SaveInvitation,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status==200) {
            if(res.data.result){
              this.inviteNumber = "";
              $(".close").trigger("click");
              $root.$toast.success("Invitation saved!");
              this.invalidInvite = '';
            }else{
              this.invalidInvite = 'invalid';
            }
          }
        });
      }
    },

    getCheckedRoles() {
      this.jobRoleIds = [];
      for (let ref of this.$refs.roleRef) {
        if (ref.checked == true) {
          this.jobRoleIds.push(ref.value);
        }
      }
    },
    getCompany() {
      this.id = this.$store.getters.getSelectedCompany.id;
      this.$axios.get(this.$GetCompany.replace(":id", this.id), {
        headers: this.getAuthHeader(),
      }).then((response) => {
        if( response.data.result.company.membership==='' || response.data.result.company.membership===null){
          this.isCompanyMembership=false;
        }

      })
    },
    showEmpCreateModal() {

      if(this.isCompanyMembership===true ||
        this.isReferBY===true ||
        this.$store.getters.getSelectedCompany.partner_customer_no !=''){
        let element = this.$refs.modal.$el
        $(element).modal('show')
        this.$root.$emit("refreshJobRoles");
      }else{
        new Swal({
          title: "Info",
          icon: "warning",
          text: "Please upgrade your plan",
          type: "info",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok!"
        }).then((result) => {
          if (result.value) {
            this.$router.push('/upgrade-plan');
          }})
      }
    },

    searchByType(type){
      this.employeeType = type;
      this.loadMoreEmployeeBtn=false;
      if(type=='all'){
        this.companyEmployees = this.totalStoredEmployees;
        this.isLoginCount=  this.companyEmployees.filter(employee =>
          employee.is_login == 1
        ).length;
      }else if(type=='current'){
        this.companyEmployees = this.totalStoredEmployees.filter((empl) => empl.is_terminate==0);
        this.isLoginCount=  this.companyEmployees.filter(employee =>
          employee.is_login == 1
        ).length;
      }else if(type=='terminate'){
        this.companyEmployees = this.totalStoredEmployees.filter(employee =>
          employee.is_terminate == 1
        );
        this.isLoginCount=0;
      }else if(type=='unverified'){
        this.companyEmployees = this.totalStoredEmployees.filter(employee =>
          employee.status == 'UN_VERIFIED' && employee.is_terminate === 0
        );
        this.isLoginCount=0;
      }
      this.employeeCount = Object.keys(this.companyEmployees).length;
      this.employeesNotFound = this.employeeCount === 0 ? true : false
    },
searchEmployees() {
    this.loadMoreCheck = false;
    this.filteredEmployees = this.totalStoredEmployees;

    // Ensure that collect.js library is imported and available
    // Define the whereLike macro
    collect().macro("whereLike", function(search) {
        var searched = new RegExp(search, "i");
        return this.filter(item =>
            searched.test(item.name) ||
            searched.test(item.phone) ||
            searched.test(item.email)
        );
    });

    if (this.search !== '') {
        // Apply the whereLike filter
        this.companyEmployees = collect(this.totalStoredEmployees)
            .whereLike(this.search)
            .all();
    } else {
        // Check if the type is 'current'
        if (this.employeeType === 'current') {
            // Assign all current employees to the companyEmployees array
            this.companyEmployees = this.totalStoredEmployees.filter(employee => employee.is_terminate === 0);
        } else {
            // Assign a slice of employees based on pagination
            this.companyEmployees = this.totalStoredEmployees.slice(0, this.employeesPerPage);
            this.loadMoreCheck = this.companyEmployees.length < this.totalStoredEmployees.length;
        }
    }

    this.currentPage = 1;
    this.employeeCount = this.totalStoredEmployees.length; 
    this.employeesNotFound = this.employeeCount === 0;
},

    loadMoreEmployee() {
    this.loadingSpin = true;
    const startIndex = this.currentPage * this.employeesPerPage;
    const newEmployees = this.totalStoredEmployees.slice(startIndex, startIndex + this.employeesPerPage);
    this.currentPage++;

    // Check if all employees have been loaded
    if (this.companyEmployees.length + newEmployees.length >= this.totalStoredEmployees.length) {
        // Separate terminated employees
        const currentEmployees = newEmployees.filter(employee => employee.is_terminate === 0);
        const terminatedEmployees = newEmployees.filter(employee => employee.is_terminate === 1);

        // Append current employees to the companyEmployees array
        this.companyEmployees = [...this.companyEmployees, ...currentEmployees];

        // Append terminated employees to the end of the companyEmployees array
        this.companyEmployees = [...this.companyEmployees, ...terminatedEmployees];
    } else {
        // Append new employees to the companyEmployees array
        this.companyEmployees = [...this.companyEmployees, ...newEmployees];
    }

    this.loadingSpin = false;
},
   async getEmployees() {
      this.loadingSpin = true;
      this.$axios({
        method    : "get",
        params    : {
          company_id  : this.$store.getters.getSelectedCompany.id,
          filter_by   : "EMPLOYEE",
        },
        url     : this.$GetEmployees,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          localStorage.setItem('companyEmployees', JSON.stringify(res.data.message.totalEmployees));
          this.employeeStorage(res.data.message.totalEmployees);
          this.loadingSpin = false;
        }
      });
    },
    filteredItems() {
      return this.totalEmployees.filter(item =>
        item.id.toString().includes(this.filters.id) &&
        item.name.toLowerCase().includes(this.filters.name.toLowerCase()) &&
        item.email.toLowerCase().includes(this.filters.email.toLowerCase()) &&
        item.uuid.toLowerCase().includes(this.filters.uuid.toLowerCase()) &&
        item.phone.includes(this.filters.phone)
      );
    },
    pswdShowHide() {
      if (this.type == "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
  },

};
</script>

<style scoped>
.profile-name{
  position    : relative;
    top       : 11px;
    left      : 12px;
    font-size : 20px;
}
.input-wrapper {
  position: relative;
}
.input-wrapper .form-control {
  padding-right : 20px;
}
.input-wrapper .ico-eye_selected {
  position  : absolute;
  top       : 50%;
  transform : translateY(-50%);
  left      : auto;
  right     : 5px;
  cursor    : pointer;
}
.textRed {
  color: red;
}

.addres-style {
  min-height  : 20px;
  display     : block;
  width       : 100%;
  overflow    : hidden;
  text-overflow: ellipsis;
  white-space : nowrap;
}
.active-tab {
  font-weight: bold;
}
</style>
